/**
 * Dónde se ofrece Rechazar en una solicitud, y a quién (SRH-322).
 *
 * Rechaza quien puede aprobar y, aparte, quien tiene el permiso «Eliminar
 * solicitudes» (no hay uno propio de rechazar). Estas pantallas (lista, tablero
 * de RH y detalle) decían cada una lo suyo; aquí queda una sola regla de en qué
 * etapas se ofrece.
 */

/**
 * Las etapas en las que el servidor acepta rechazar y que la pantalla ofrece:
 * pendiente de pre-aprobación y de aprobación de salario. Una devuelta no: el
 * servidor la rechaza con un error porque espera la respuesta del solicitante.
 */
const ESTADOS_DONDE_SE_RECHAZA = [
  'pendiente_pre_aprobacion',
  'pendiente_aprobacion_salario',
  'en_revision',
]

export const seRechazaEnEstado = (status: string): boolean =>
  ESTADOS_DONDE_SE_RECHAZA.includes(status)

/**
 * La lista de acciones de una solicitud con Rechazar puesto o quitado según el
 * permiso. Respeta el resto de las acciones tal cual vienen.
 */
export const conRechazo = <A extends string>(
  acciones: readonly A[],
  puedeRechazar: boolean,
  status: string,
): Array<A | 'reject'> => {
  const sinRechazo = acciones.filter((accion) => accion !== 'reject')
  return puedeRechazar && seRechazaEnEstado(status)
    ? [...sinRechazo, 'reject']
    : sinRechazo
}
